import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';

const BreadcCrum = ({ breadcrumb }) => (
  <div className="breadcrumb-container" dangerouslySetInnerHTML={{ __html: breadcrumb }} />
);

const mapStateToProps = ({ seo }) => ({ breadcrumb: seo?.metaData?.breadcumb });

export default connect(mapStateToProps, null)(BreadcCrum);
